import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {FullComponent} from "./layouts/full/full.component"
import {BlankComponent} from './layouts/blank/blank.component';
import {AuthGuard} from './guards/auth.guard';


const routes: Routes = [

  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/authentication/login',
        pathMatch: 'full'
      },
      // {
      //   path:''
      // },
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'apps',
        loadChildren: () => import('./pages/apps/apps.module').then((m) => m.AppsModule),
      },
      {
        path: 'dashboards',
        loadChildren: () => import('./pages/dashboards/dashboards.module').then((m) => m.DashboardsModule),
      },
      {
        path: 'client-dashboard',
        loadChildren: () => import('./pages/external-dashboards/external-dashboards.module').then((m) => m.ExternalDashboardsModule),
      },
      {
        path: 'one-way',
        loadChildren: () => import('./pages/one-way/one-way.module').then((m) => m.OneWayModule),
      },
      {
        path: 'my-account',
        loadChildren: () => import('./pages/my-account/my-account.module').then((m) => m.MyAccountModule),
      },
      {
        path: 'master-data',
        loadChildren: () => import('./pages/master-data/master-data.module').then((m) => m.MasterDataModule),
      },
      {
        path: 'requests',
        loadChildren: () => import('./pages/one-way-data/one-way-data.module').then((m) => m.OneWayDataModule),
      },
      {
        path: 'master-search',
        loadChildren: () => import('./pages/master-search/master-search.module').then((m) => m.MasterSearchModule),
      },
      {
        path: 'datatables',
        loadChildren: () => import('./pages/datatables/datatables.module').then((m) => m.DatatablesModule),
      },
      {
        path: 'tables',
        loadChildren: () => import('./pages/tables/tables.module').then((m) => m.TablesModule),
      },
      {
        path: 'forms',
        loadChildren: () => import('./pages/forms/forms.module').then((m) => m.FormModule),
      },
      {
        path: 'charts',
        loadChildren: () => import('./pages/charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'sample-pages',
        loadChildren: () => import('./pages/sample-pages/sample-pages.module').then((m) => m.SamplePagesModule),
      },
      {
        path: 'tree',
        loadChildren: () => import('./pages/tree/tree.module').then((m) => m.TreeModule),
      },
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./pages/authentication/authentication.module').then((m) => m.AuthenticationModule),
      },
      {
        path: 'web-request',
        loadChildren: () => import('./pages/web-request/web-request.module').then((m) => m.WebRequestModule),
      }

    ]
  },
  {
    path: '**',
    redirectTo: 'auth/error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
